var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "iframe-container" }, [
    _c("iframe", { attrs: { frameborder: "0", src: _vm.url } })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }